import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreativeListComponent } from './components/creative-list/creative-list.component';
import { AppCommonModule } from 'src/app/common/common.module';
import { CreativeAdapter } from 'src/adapters/creative-adapter';
import { CreativePreviewComponent } from './components/creative-preview/creative-preview.component';
import { CreativePreviewContentComponent } from './components/creative-preview-content/creative-preview-content.component';

const components = [
  CreativeListComponent,
  CreativePreviewComponent,
  CreativePreviewContentComponent
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    AppCommonModule
  ],
  exports: [CreativeListComponent],
  providers: [CreativeAdapter]
})
export class CreativeListModule { }
